export const API = {
  TIMEOUT: 2000,
  BEARER_TOKEN: 'bearerToken',
}
